import { Truck } from 'lucide-react';

interface OppCourierHeaderCardProps {
  name: string;
  level: number;
  title?: string;
  badgeBg?: string;
  badgeText?: string;
}

export function OppCourierHeaderCard({ name, level, title, badgeBg, badgeText }: OppCourierHeaderCardProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full" style={{ backgroundColor: badgeBg }}>
          <Truck className="h-5 w-5" style={{ color: badgeText }} />
        </div>
        <div>
          <p className="text-sm font-bold text-[hsl(var(--opp-ink))]">{name}</p>
          <div className="flex items-center gap-1.5">
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: badgeText }} />
            <span className="text-label font-semibold" style={{ color: badgeText }}>
              L{level} {title}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
